import { ReactNode, useEffect, useState } from 'react'

import { cn } from '@/utils/style'

import { Button } from './Button'

export interface ButtonRadioItem<T> {
  label: ReactNode
  value: T
  disabled?: boolean
}

interface ButtonRadioProps<T> {
  items: ButtonRadioItem<T>[]
  className?: string
  unselectedClassName?: string
  value?: T
  onChange?: (value: T) => void
  disabled?: boolean
  size?: 'small' | 'large'
}

export function ButtonRadio<T = any>({
  items,
  value,
  className,
  onChange,
  disabled = false,
  unselectedClassName,
  size = 'large',
}: ButtonRadioProps<T>) {
  const [select, setSelect] = useState<T | undefined>(value ?? items?.[0]?.value)

  useEffect(() => {
    if (value) {
      setSelect(value)
    }
  }, [value])

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {items.map(({ label, value, disabled: itemDisabled }, idx) => {
        return (
          <Button
            disabled={disabled || itemDisabled}
            key={idx}
            className={cn('t-sb', {
              't-sb': size === 'large',
              't-x-sb': size === 'small',
              'bg-btn-secondary/10 text-btn-secondary': value === select,
              'text-tertiary cursor-not-allowed': disabled || itemDisabled,
              [unselectedClassName ?? '']: value !== select,
            })}
            onClick={() => {
              if (disabled) return
              onChange?.(value)
              setSelect(value)
            }}
          >
            {label}
          </Button>
        )
      })}
    </div>
  )
}
